import React, { useEffect, useState, useMemo, useRef } from "react";
import { validators } from "investira.sdk";
import { useSelector } from "react-redux";
import { INDICADOR_TIPO } from "@investirapri/financa.js/lib/enums";
import {
  Stack,
  Typography,
  Autocomplete,
  TextField,
  Select,
  MenuItem,
} from "investira.react.components";

// TODO:
// 1 - Seleção do tipo de indicador
// 2 - Pesquisa com autocomplete
// 3 - Limpar pesquisa ao trocar o tipo de indicador, limpar formik
// 4 - Atualizar o formik
// 5 - Props para o autocomplete
// 6 - Conectar com lista de indicadores
// 7 - Conectar com pesquisa de indicadores
// 8 - Atualizar o form através do handleChange ao seleconar o indicador

// Talvez seja uma boa abordagem sempre que selecionar o tipo de ativo realizar
// o request e armazenar os idnicadores

const BenchmarkInput = (props) => {
  const { label = "Indicador", value = null } = props;

  const autoCompleteRef = useRef();

  const [indicadorTipoId, setIndicadorTipoId] = useState("I");
  const [indicadorValue, setIndicadorValue] = useState(null);

  const storedIndicadores = useSelector((store) => store.indicadores.data);

  function handleChange(pValue) {
    props.onChange && props.onChange(pValue);
  }

  const xIndicadores = useMemo(
    () => storedIndicadores[indicadorTipoId] || [],
    [indicadorTipoId, storedIndicadores]
  );

  const xOptions = Object.values(xIndicadores).sort(
    (a, b) => -b.indicador.localeCompare(a.indicador)
  );

  useEffect(() => {
    if (!validators.isNull(value)) {
      const xIndicadores = storedIndicadores[indicadorTipoId];
      const xValue = (xIndicadores || []).filter((xIndicador) => {
        return xIndicador?.indicador_id === value;
      })[0];

      setIndicadorValue(xValue);
    } else {
      setIndicadorValue(null);
    }
  }, [value, indicadorTipoId, storedIndicadores]);

  return (
    <Stack sx={{ width: "100%" }}>
      <Stack>
        <Typography variant="caption" color="textSecondary">
          {label}
        </Typography>
      </Stack>
      <Stack direction="row" flexGrow={1}>
        <Stack flexGrow={0} sx={{ minWidth: 220, mr: 2 }}>
          <Select
            id="indicador_select"
            value={indicadorTipoId}
            onChange={(e) => {
              setIndicadorTipoId(e.target.value);
              // Limpa o valor selecionado ao trocar o tipo
              props.onChange && props.onChange(null);
            }}
            fullWidth
            size="small"
            sx={{
              height: "100%",
            }}
          >
            {Object.values(INDICADOR_TIPO)
              .filter((tipo) => tipo.id !== "T")
              .map((tipo) => (
                <MenuItem key={tipo.id} value={tipo.id}>
                  {tipo.descricao}
                </MenuItem>
              ))}
          </Select>
        </Stack>
        <Stack flexGrow={1}>
          <Autocomplete
            ref={autoCompleteRef}
            id={props.id || "indicador_id"}
            disablePortal
            options={xOptions}
            value={indicadorValue}
            onChange={(e, pValue) => {
              //setValue(pValue);
              handleChange(pValue?.indicador_id || null);
            }}
            getOptionLabel={(option) => {
              return !validators.isNull(option?.indicador)
                ? option.indicador
                : "";
            }}
            renderOption={(props, option) => {
              const { key, ...optionProps } = props;
              return (
                <li key={crypto.randomUUID()} {...optionProps}>
                  <Stack
                    direction="row"
                    flexGrow={1}
                    spacing={3}
                    alignItems="flex-start"
                  >
                    <Stack flexGrow={1}>
                      <Typography
                        variant="body2"
                        color="textPrimary"
                        sx={{ fontWeight: 600 }}
                      >
                        {`${option.indicador_id} - ${option.indicador}`}
                      </Typography>
                    </Stack>
                  </Stack>
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                //label="Indicador"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  border: 0,
                }}
                fullWidth
              />
            )}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BenchmarkInput;
